var xorwow = {exports: {}};

export { xorwow as __module };
//# sourceMappingURL=xorwow.js.map
